import { createContext, useContext, useState } from "react";

export const ConfigContext = createContext();

export const useConfig = () => {
    return useContext(ConfigContext)
}


export const ConfigProvider = ({ children }) => {

    const [isMiniCartOpen, setIsMiniCartOpen] = useState(false);

    return (
        <ConfigContext.Provider value={{ isMiniCartOpen, setIsMiniCartOpen }}>
            {children}
        </ConfigContext.Provider>
    )
}